/* eslint-disable import/no-named-as-default-member */
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import { Cached, Gavel, LibraryAdd, PieChart } from "@material-ui/icons";
import moment from "moment";
import {
  getLoansByDealIdAndStatus,
  setDealToRefinance,
  acknowledgeRedirect,
  getDealToSell,
  sellDeal,
  recalculateDealExitDebtYield,
  getSalesBrokers,
  getContactsByCompany,
} from "./changeDealStatusModal.store";
import SlidingConfirmSection from "./SlidingConfirmSection";
import loanStatuses from "../../constants/loanStatuses";
import SellDealWizardModal from "./SellDealWizardModal";
import PartialReleaseWizardModal from "./PartialReleaseWizardModal";

const ICON_COLOR = "rgb(1,169,121)";

const StyledDialogIconButton = styled(IconButton)`
  && {
    position: absolute;
    top: 8px;
    right: 13px;
  }
`;

const StyledDialog = styled(Dialog)`
  &&& {
    min-width: 700px;
  }
`;

const StyledDialogContent = styled(DialogContent)`
  && {
    padding: 28px;
    min-height: 350px;
    overflow-x: hidden;
    overflow-y: auto;
  }
`;

const ModalTitle = styled.p`
  font-weight: normal;
  font-size: 17pt;
  margin-left: 20px;
`;

class ChangeDealStatusModal extends Component {

  constructor(props) {
    super(props);
    this.formik = React.createRef();
    this.state = {
      isNewDeal: true,
      isInitialized: false,
      isEditing: false,
      isEditImage: false,
      modalOpen: false,
      isNotesOpen: false,
      isAttachmentsOpen: false,
      popupOpen: false,
      changeStatusModalOpen: false
    };
  }

  componentDidMount() {
    this.props.getLoansByDealIdAndStatus({ dealId: this.props.deal.id, loanStatusId: loanStatuses.CLOSED_LOAN });
  }

  setDealToRefinance = () => {
    this.props.setDealToRefinance({ dealId: this.props.deal.id, callback: this.props.handleClose });
  }

  hasMultipleUnsoldProperties = () => {
    let num = 0;
    if (this.props.deal && this.props.deal.properties) {
      this.props.deal.properties.forEach(property => {
        if (!property.actualExitDate) num++;
      });
    }
    return num > 1;
  }

  render() {
    const { isOpen, handleClose, closedLoans } = this.props;
    let isSeniorLoanNew = false;
    let supplementalAvailableDate;

    if (closedLoans && closedLoans.length > 0) {
      const oneYearAgo = moment().subtract("years", 1);
      for (let closedLoanIndex = 0; closedLoanIndex < closedLoans.length; closedLoanIndex++) {
        const closedLoan = closedLoans[closedLoanIndex];
        if (closedLoan.closingDate) {
          const closingDate = moment(closedLoan.closingDate);
          if (!closingDate.isBefore(oneYearAgo)) {
            isSeniorLoanNew = true;
            const oneYearAfterClosingDate = closingDate.add("years", 1);
            if (!supplementalAvailableDate || supplementalAvailableDate.isAfter(oneYearAfterClosingDate)) {
              supplementalAvailableDate = oneYearAfterClosingDate;
            }
          }
        }
      }
    }

    const shouldShowPartialRelease = this.hasMultipleUnsoldProperties();

    return (<>
      <StyledDialog
        modal
        maxWidth="md"
        fullWidth
        open={isOpen}
        autoDetectWindowHeight={false}
        autoScrollBodyContent={false}
        contentStyle={{ width: "700px", maxWidth: "none" }}
        onClose={() => handleClose()}
      >
        <ModalTitle>Change Deal Status</ModalTitle>
        <StyledDialogIconButton onClick={() => handleClose()}>
          <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
        </StyledDialogIconButton>
        <StyledDialogContent>
          <SlidingConfirmSection
            icon={<Cached style={{ marginBottom: "-5px", color: ICON_COLOR }} />}
            title="REFINANCE"
            description="Replace existing loans with completely new loans and quotes. This requires you to pay off all existing active loans and to terminate existing active hedges."
            primaryButtonText="BEGIN"
            confirmText="YES, REFINANCE"
            cancelText="NO, CANCEL"
            onConfirm={this.setDealToRefinance}
            containerStyle={{ marginBottom: "20px" }}
          />
          <SlidingConfirmSection
            icon={<Gavel style={{ marginBottom: "-5px", color: ICON_COLOR }} />}
            title="MODIFY"
            description="Modify the terms of an existing loan. This will create a copy of the loan in its current state for historical reference."
            primaryButtonText="BEGIN"
            confirmText="YES, MODIFY LOAN"
            cancelText="NO, CANCEL"
            onConfirm={() => handleClose("modify")}
            containerStyle={{ marginBottom: "20px" }}
          />
          <SlidingConfirmSection
            icon={<LibraryAdd style={{ marginBottom: "-5px", color: ICON_COLOR }} />}
            title="ADD SUPPLEMENTAL"
            description={`Add a supplemental loan to this deal. This will create a copy of this deal in Pipeline and allow you to gather supplemental quotes.${isSeniorLoanNew && supplementalAvailableDate
              ? ` (NOTE: You are not qualified for a supplemental loan until ${supplementalAvailableDate.format("MM/DD/YYYY")}.)`
              : ""
              }`}
            primaryButtonText="BEGIN"
            confirmText="YES, ADD SUPPLEMENTAL"
            cancelText="NO, CANCEL"
            onConfirm={() => handleClose("addSupplemental")}
            containerStyle={{ marginBottom: "20px" }}
          />
          {shouldShowPartialRelease &&
            <SlidingConfirmSection
              icon={<PieChart style={{ marginBottom: "-5px", color: ICON_COLOR }} />}
              title="PARTIAL RELEASE"
              description="Sell some of the properties on this deal to another company."
              primaryButtonText="BEGIN"
              confirmText="YES, PARTIAL RELEASE"
              cancelText="NO, CANCEL"
              onConfirm={() => { handleClose("partialRelease"); this.setState({ showPartialReleaseModal: true }); }}
              containerStyle={{ marginBottom: "20px" }}
            />
          }
          <SlidingConfirmSection
            icon={<Gavel style={{ marginBottom: "-5px", color: ICON_COLOR }} />}
            title="SOLD"
            description="Sell this deal and its properties to another company."
            primaryButtonText="BEGIN"
            confirmText="YES, SELL DEAL"
            cancelText="NO, CANCEL"
            onConfirm={() => {handleClose("sold"); this.setState({ showSellDealModal: true }); }}
            containerStyle={{ marginBottom: "20px" }}
          />
        </StyledDialogContent>
      </StyledDialog>
      {this.state.showSellDealModal && 
        <SellDealWizardModal
          dealId={this.props.deal.id}
          onClose={() => this.setState({ showSellDealModal: false })} />}
      {this.state.showPartialReleaseModal && 
        <PartialReleaseWizardModal
          dealId={this.props.deal.id}
          onClose={() => {
                          this.setState({showPartialReleaseModal: false});
                          this.props.deal.properties.forEach(x => x.shouldDisposition=false);
                        }}
        />
      }
      {/* {this.renderModifyLoansModal()} */}
    </>
    );
  }
}

function mapStateToProps({ changeDealStatusModal }) {
  return {
    ...changeDealStatusModal,
    closedLoans: changeDealStatusModal.loansByStatus[loanStatuses.CLOSED_LOAN] ? changeDealStatusModal.loansByStatus[loanStatuses.CLOSED_LOAN].loans : null
  };
}

export default compose(
  connect(mapStateToProps, {
    getLoansByDealIdAndStatus,
    setDealToRefinance,
    acknowledgeRedirect,
    getDealToSell,
    sellDeal,
    recalculateDealExitDebtYield,
    getSalesBrokers,
    getContactsByCompany,
  })
)(ChangeDealStatusModal);
